// extracted by mini-css-extract-plugin
module.exports = {"LoaderInfo":"EmailVerification_LoaderInfo__3GhMK","Info":"EmailVerification_Info__HJw2O","Text":"EmailVerification_Text__1cuyd"};